<div class="row">
  <div class="col-12">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a [routerLink]="['/build-configs']">Build Configs</a></li>
      <li class="breadcrumb-item">{{config?.name}}</li>
      <li class="breadcrumb-item">{{config?.application}}&nbsp;<a (click)="showBuildConfig()" class="ml-2"><i
        class="fal fa-edit"></i></a></li>
    </ol>
  </div>
</div>

<div class="row builds">
  <div class="col-12">
    <dx-data-grid
      (onRowExpanding)="onRowExpanding($event)"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      [allowColumnReordering]="true"
      [allowColumnResizing]="true"
      [dataSource]="builds"
      [hoverStateEnabled]="true"
      [masterDetail]="{ enabled: true, template: 'detail' }"
      [remoteOperations]="false"
      [showBorders]="true"
      id="gridContainer"
      keyExpr="id">

      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-paging [enabled]="true"></dxo-paging>
      <dxo-state-storing [enabled]="true" storageKey="build-config.v7"
                         type="localStorage"></dxo-state-storing>

      <dxi-column [allowReordering]="false" [allowResizing]="false" caption="" cellTemplate="empty"
                  headerCellTemplate="refreshLink" width="10px"></dxi-column>
      <dxi-column caption="Action" cellTemplate="detail-link" width="92px"></dxi-column>
      <dxi-column cellTemplate="release-notes" dataField="release" width="100px"></dxi-column>
      <dxi-column [format]="'dd/MM/yyyy HH:mm'" dataField="created" dataType="date" width="100px"></dxi-column>
      <dxi-column dataField="status" width="100px"></dxi-column>
      <dxi-column dataField="published" width="100px"></dxi-column>
      <dxi-column dataField="syncStatus" width="100px"></dxi-column>
      <dxi-column dataField="commitId"></dxi-column>

      <div *dxTemplate="let r of 'detail-link'">
        <!--      <dx-button (click)="publish(r.data)" *ngIf="!r.data.published"  icon="fas fa-fast-forward" text="Build"></dx-button>-->
        <a (click)="publish(r.data)" *ngIf="!r.data.published" class="detail-link publish"><i class="fal fa-cog"></i>&nbsp;Publish</a>
        <a (click)="unpublish(r.data)" *ngIf="r.data.published" class="detail-link unpublish"><i class="fas fa-ban"></i>&nbsp;Hide</a>
      </div>

      <div *dxTemplate="let r of 'release-notes'">
        <div class="d-flex flex-row">
          <div class="flex-grow-1 flex-shrink-1">
            <a (click)="buildReleaseNotes = r.data" class="release-notes-link">
              <span class="mr-2">{{r.data.release}}</span>
            </a>
          </div>
          <!--        <div class="flex-shrink-0 align-self-end">-->
          <!--          <a (click)="buildReleaseNotes = r.data;"><i class="fal fa-book-dead"></i></a>-->
          <!--          <span *ngIf="getReleaseNoteStatus(r.data) != ''" class="ml-1">({{getReleaseNoteStatus(r.data)}})</span>-->
          <!--        </div>-->
        </div>

      </div>

      <div *dxTemplate="let record of 'refreshLink'">
        <a (click)="refresh()"><i class="fal fa-sync"></i></a>
      </div>

      <div *dxTemplate="let record of 'empty'">
      </div>

      <div *dxTemplate="let record of 'gridTitle'">
        <div>
          <h5>Builds</h5>
        </div>
      </div>

      <div *dxTemplate="let record of 'detail'">

        <div *ngIf="record.data.status == 'SUCCESS'" class="artifacts detail-item">
          <div class="master-detail-caption">Artifacts</div>
          <dx-data-grid
            [columnAutoWidth]="true"
            [dataSource]="getArtifacts(record.data)"
            [loadPanel]="{enabled: false}"
            [remoteOperations]="false"
            [showBorders]="true">
            <dxi-column cellTemplate="download" dataField="name" width="300px"></dxi-column>
            <dxi-column dataField="syncStatus" width="100px"></dxi-column>
            <dxi-column dataField="size" width="100px"></dxi-column>
            <dxi-column dataField="checksum"></dxi-column>

            <div *dxTemplate="let record of 'download'">
              <a (click)="downloadArtifact(findBuild(record.data), record.data)"
                 *ngIf="getDownloadStatus(record.data) == ''"><i
                class="fa fa-download"></i>&nbsp;{{record.data.name}}</a>
              <span *ngIf="getDownloadStatus(record.data) != ''"><i
                class="fa fa-download"></i>&nbsp;{{record.data.name}}
                ({{getDownloadStatus(record.data)}})</span>
            </div>
          </dx-data-grid>
        </div>

        <div class="logs detail-item">
          <div class="master-detail-caption">Logs</div>
          <dx-data-grid
            [columnAutoWidth]="true"
            [dataSource]="getLogs(record.data)"
            [loadPanel]="{enabled: false}"
            [remoteOperations]="false"
            [showBorders]="true">
            <dxi-column dataField="dateTime" dataType="date" format="dd/MM/yyyy HH:mm:ss"></dxi-column>
            <dxi-column dataField="message"></dxi-column>
          </dx-data-grid>
        </div>

      </div>

    </dx-data-grid>
  </div>


  <dx-popup (onHidden)="buildReleaseNotes = null" *ngIf="buildReleaseNotes" [closeOnOutsideClick]="true"
            [visible]="buildReleaseNotes" height="auto"
            title="Release Notes: {{buildReleaseNotes?.release}}" width="600">

    <form (ngSubmit)="generateReleaseNotes(buildReleaseNotes, formReleaseNotes.value?.method)"
          [formGroup]="formReleaseNotes" class="generate-release-notes">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-item">
              <div class="form-component">
                <dx-radio-group (valueChange)="changeReleaseNoteMethod()" [items]="['Download Only', 'Email']"
                                formControlName="method" layout="horizontal"></dx-radio-group>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="formReleaseNotes.value?.method === 'Email'" class="row mt-4">
          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="email">Email</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'email'}" [isValid]="isValid(formReleaseNotes, 'email')"
                             formControlName="email"></dx-text-box>
              </div>
            </div>
          </div>
        </div>


        <div *ngIf="formReleaseNotes.value?.method === 'Email'" class="row">
          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="subject">Subject</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'subject'}" [isValid]="isValid(formReleaseNotes, 'subject')"
                             formControlName="subject"></dx-text-box>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 pt-3 action d-flex flex-row justify-content-center">
            <dx-button
              [icon]="getReleaseNoteStatus(buildReleaseNotes) != '' ? 'fa fa-spinner fa-pulse fa-3x fa-fw' : ''"
              [useSubmitBehavior]="true"
              text="Generate">
            </dx-button>
          </div>
        </div>
      </div>
    </form>

  </dx-popup>

  <dx-popup (onHidden)="editBuildConfig = false" *ngIf="config" [closeOnOutsideClick]="true"
            [visible]="editBuildConfig" height="auto"
            title="Build Config: {{config.name}}" width="auto">

    <form (ngSubmit)="saveBuildConfig()" [formGroup]="formBuildConfig">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="name">Customer Name</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'name'}" [isValid]="isValid(formBuildConfig, 'name')"
                             formControlName="name"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="application">Application</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'application'}" [isValid]="isValid(formBuildConfig, 'application')"
                             formControlName="application"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="externalId">External Id</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'externalId'}" [isValid]="isValid(formBuildConfig, 'externalId')"
                             formControlName="externalId"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="gitRepository">Git Repository</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'gitRepository'}" [isValid]="isValid(formBuildConfig, 'gitRepository')"
                             formControlName="gitRepository"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="jiraProject">Jira</label>
              <div class="form-component">
                <dx-select-box [dataSource]="jiraProjects"
                               [displayExpr]="getJiraDisplayText" [inputAttr]="{id: 'jiraProject'}"
                               [isValid]="isValid(formBuildConfig, 'jiraId')"
                               [searchEnabled]="true"
                               [searchTimeout]="0"
                               [showDataBeforeSearch]="true" formControlName="jiraId" valueExpr="id">
                </dx-select-box>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="jiraCustomerLabel">Jira Label</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'jiraCustomerLabel'}"
                             [isValid]="isValid(formBuildConfig, 'jiraCustomerLabel')"
                             formControlName="jiraCustomerLabel"></dx-text-box>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="form-item">
              <label class="label col-4 col-xl-3" for="releaseNotesEmail">Release Note Email</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'releaseNotesEmail'}"
                             [isValid]="isValid(formBuildConfig, 'releaseNotesEmail')"
                             formControlName="releaseNotesEmail"></dx-text-box>
              </div>
            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-end">
              <div class="mr-1">
                <dx-button [disabled]="!formBuildConfig.valid" [useSubmitBehavior]="true" text="Save"></dx-button>
              </div>
              <div>
                <dx-button (onClick)="editBuildConfig = false" [useSubmitBehavior]="false" text="Cancel"></dx-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </dx-popup>


  <dx-popup (onHidden)="showAddBuild = false" *ngIf="showAddBuild" [closeOnOutsideClick]="true"
            [visible]="showAddBuild" height="auto"
            minWidth="500px" title="Add Build" width="auto">

    <form (ngSubmit)="saveBuild()" [formGroup]="formAddBuild">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="form-item">
              <label class="label required col-4 col-xl-3" for="release">Release</label>
              <div class="form-component">
                <dx-text-box [inputAttr]="{id: 'release'}" [isValid]="isValid(formAddBuild, 'release')"
                             formControlName="release"></dx-text-box>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="d-flex justify-content-end">
              <div class="mr-1">
                <dx-button [disabled]="!formAddBuild.valid" [useSubmitBehavior]="true" text="Save"></dx-button>
              </div>
              <div>
                <dx-button (onClick)="showAddBuild = false" [useSubmitBehavior]="false" text="Cancel"></dx-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </dx-popup>
</div>


